import { stringify } from "yaml";
import { ComponentTypes } from "@bcc/core-renderers";
import type { ComponentDefinition } from "./pageComponentLibrary.types";

const clone = <T,>(value: T): T => JSON.parse(JSON.stringify(value));

/** New component instance; key is generated at runtime from index when added to the page. */
export const createComponentInstance = (definition: ComponentDefinition) => ({
	componentType: definition.type,
	content: clone(definition.defaultContent)
});

/** Default markdown block for a component. ArticleHero uses fenced ```ArticleHero; others use ::: Type ... ::: */
export function getDefaultBlockMarkdown(definition: ComponentDefinition): string {
	const instance = createComponentInstance(definition);
	const body: Record<string, unknown> = { ...(instance.content as Record<string, unknown>) };

	if (definition.type === ComponentTypes.ArticleHero) {
		// Fenced block format with image shorthand
		const img = body.featuredImage as { src?: string; alt?: string } | undefined;
		const rest = { ...body };
		delete rest.featuredImage;
		delete rest.shareLabel;
		delete rest.shareOptions;
		if (img?.src) rest.image = `${img.src} | ${img.alt ?? "Image"}`;
		for (const k of ["eyebrow", "summary", "author", "authorRole", "publishDate"]) {
			if (rest[k] === "" || rest[k] == null) delete rest[k];
		}
		const yamlBody = stringify(rest, { indent: 2 }).trim();
		return `\`\`\`ArticleHero\n${yamlBody}\n\`\`\``;
	}

	const yamlBody = stringify(body, { indent: 2 }).trim();
	return `${definition.type}\n${yamlBody}\n:::`;
}

/** Default image used for new component defaultContent and preview (prerender). */
export const DEFAULT_PRERENDER_IMAGE = "images/d47f9f5af24fd7129274afad903571dd3819a330 (1).png";
